import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { addIcons } from 'ionicons';
import {
  add,
  addCircle,
  alert,
  alertCircleOutline,
  arrowBack,
  arrowBackOutline,
  arrowUpCircle,
  cardOutline,
  chatbox,
  chatbubbles,
  checkboxOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkDoneCircle,
  chevronBackOutline,
  chevronDownCircleOutline,
  chevronForwardOutline,
  chevronUpCircleOutline,
  close,
  closeCircle,
  closeOutline,
  colorWandOutline,
  ellipse,
  ellipsisVerticalOutline,
  eyeOffOutline,
  eyeOutline,
  footstepsOutline,
  globe,
  grid,
  gridOutline,
  handRightOutline,
  heart,
  logIn,
  logInOutline,
  logoBuffer,
  logoFacebook,
  logOut,
  logoWhatsapp,
  mail,
  mailOpen,
  man,
  options,
  paperPlane,
  pencilOutline,
  people,
  personAdd,
  refreshOutline,
  removeCircle,
  ribbon,
  rocketOutline,
  search,
  send,
  settings,
  share,
  shieldCheckmark,
  squareOutline,
  star,
  starOutline,
  thumbsDown,
  thumbsUp,
  trash,
} from 'ionicons/icons';
import { UniqueDeviceID } from '@awesome-cordova-plugins/unique-device-id/ngx';
import { Badge } from '@awesome-cordova-plugins/badge/ngx';
import { Globalization } from '@awesome-cordova-plugins/globalization/ngx';
import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics/ngx';
import { Market } from '@awesome-cordova-plugins/market/ngx';
import { LanguageProvider } from './app/providers/language';
import { AgentsService } from './app/providers/crm-agent-provider';
import { EncriptionService } from './app/providers/encription.service';
import { GlobalDataService } from './app/providers/global-data.service';
import { GuestService } from './app/providers/guest.service';
import { EmailServices } from './app/providers/email-services';
import { UserCollectionsServices } from './app/providers/user-collection-services';
import { GroupServices } from './app/providers/group-services';
import { ErrorHandlingProvider } from './app/providers/error-handling';
import { DataProvider } from './app/providers/data';
import { FileServices } from './app/providers/files-provider';
import { MessagingServicesProvider } from './app/providers/messaging-services';
import { OneSignalApi } from './app/providers/onesignal-services';
import { AdsServicesService } from './app/providers/ads-services.service';
import { Storage, Drivers } from '@ionic/storage';
import {
  provideRouter,
  RouteReuseStrategy,
  withRouterConfig,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import {
  HttpClient,
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
  provideHttpClient,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AdsenseModule } from 'ng2-adsense';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { QuillModule } from 'ngx-quill';
import { appRoutes } from './app/app.routes';
import { register } from 'swiper/element/bundle';
import { AdvertizingImpressionComponent } from './app/components/advertizing-impression/advertizing-impression.component';
import { AdvertizingPrizeComponent } from './app/components/advertizing-prize/advertizing-prize.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';

register();

if (environment.production) {
  enableProdMode();
  console.log = function () {};
}

function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      IonicStorageModule.forRoot({
        name: '__exmedb',
        driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
      }),
      AdsenseModule.forRoot({
        adClient: 'ca-pub-8915683900096700',
        adSlot: 2912405580,
      }),
      QuillModule.forRoot()
    ),
    UniqueDeviceID,
    Badge,
    Globalization,
    GoogleAnalytics,
    Market,
    // AppRate,
    LanguageProvider,
    AgentsService,
    EncriptionService,
    GlobalDataService,
    GuestService,
    EmailServices,
    UserCollectionsServices,
    GroupServices,
    ErrorHandlingProvider,
    DataProvider,
    FileServices,
    MessagingServicesProvider,
    OneSignalApi,
    AdsServicesService,
    Storage,
    AdvertizingImpressionComponent,
    AdvertizingPrizeComponent,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({ innerHTMLTemplatesEnabled: true }),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideAnimations(),
    provideRouter(
      appRoutes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
}).catch((err) => console.log(err));
